module.exports = __webpack_public_path__ + "media/mouse-look.1d3d0467.mp4";